/* ================================================================
   BRITTEN CUSTOM: Your Britten, email sign-in link
   ================================================================
   Added:     2 Oct 2026
   Author:    Claude / Matthew
   Location:  assets/britten-yb-link.js (+ .css), loaded by snippets/britten-yb-saved.liquid only,
              deferred, and only when settings.britten_your_britten_signin is on
   Spec:      docs/britten-core-CONTRACT.md section 15

   PURPOSE:
   The sign-in email carries a button to /pages/saved#yb-code=<6 to 10 digits>. This file turns that
   tap into a signed-in bride where it safely can, and into a code she can read and copy where it cannot.

   HOW IT WORKS:
   1. The code is in the URL fragment, so no server ever sees it. It is read once, removed from the
      address bar at once (never left in history) and kept only in a variable here.
   2. Verifying needs the email AND the code. If this browser asked for the code (britten-your-britten.js
      stored { email, at } at store yb/pending, under an hour old) the page's own sign-in block is put into
      a calm "Signing you in" state and session.verify(email, code) runs. The result goes back to the block
      through the britten:yb:link event, which shows the welcome step (good) or the code step with its
      usual calm message (not good).
   3. Any other browser (a phone's in-app browser, another device) has no pending email, so the code is NOT
      used. [data-yb-link-card] shows it with a Copy button ("enter it in the tab where you asked for it")
      and "Or sign in on this device": her email plus THIS code, straight to session.verify. It never asks
      for a new code, which would cancel this one.
   4. Does nothing without a #yb-code fragment, with the sign-in switch off, or when she is signed in.
   5. Emits signin_link_open { tool, same_browser } once.

   CHANGELOG:
   - 2 Oct 2026: built.
   - 2 Oct 2026: the email note clears as she types a new address.
   ================================================================ */
(function () {
  'use strict';

  // === CONFIGURATION ===
  var FEATURE_ENABLED = true;
  var DEBUG_MODE = false;

  var CFG = window.BrittenCoreConfig;
  if (!FEATURE_ENABLED || !CFG) return;
  if (!window.Promise) return;

  var TOOL = 'your-britten';
  var SLOT = 'yb';                              // the tool slot britten-your-britten.js registers
  var CODE_HASH = /^#yb-code=(\d{6,10})$/;
  var FRESH_MS = 60 * 60 * 1000;                // a pending email older than this is not used
  var EMAIL = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

  var core = null;
  var i18n = null;   // the name must end in i18n: scripts/i18n-js-keys-check.py finds call sites by it
  var code = '';     // the only copy of the code; never stored, never logged

  // === HELPERS ===
  function log(m) { if (DEBUG_MODE && window.console) console.log('[Britten YB link]', m); }
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  function pendingEmail() {
    var p = core.store.get(SLOT, 'pending', null), t = p ? Date.parse(p.at) : NaN;
    return p && typeof p.email === 'string' && p.email && !isNaN(t) && Date.now() - t < FRESH_MS ? p.email : '';
  }
  function verify(email) {
    return Promise.resolve(core.session.verify(email, code)).then(function (r) { return r || { ok: false, reason: 'network' }; },
      function () { return { ok: false, reason: 'network' }; });
  }
  // The sign-in block in britten-your-britten.js owns the welcome step and the code step.
  function handOver(detail) {
    try { document.dispatchEvent(new CustomEvent('britten:yb:link', { detail: detail })); } catch (e) { log('handOver'); }
  }
  // 123 456, 1234 5678
  function group(c) {
    var n = c.length % 4 === 0 ? 4 : c.length % 5 === 0 ? 5 : 3;
    return c.replace(new RegExp('(\\d{' + n + '})(?=\\d)', 'g'), '$1 ');
  }
  function copyText(text) {
    function old() {
      var ta = document.createElement('textarea'), ok = false;
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0';
      document.body.appendChild(ta);
      ta.select();
      try { ta.setSelectionRange(0, text.length); ok = document.execCommand('copy'); } catch (e) { log('copy'); }
      document.body.removeChild(ta);
      return ok;
    }
    if (window.navigator.clipboard && window.navigator.clipboard.writeText) {
      return window.navigator.clipboard.writeText(text).then(function () { return true; }, function () { return old(); });
    }
    return Promise.resolve(old());
  }

  // --- same browser: no typing ---
  function auto(email) {
    var root = $('[data-yb-signin][data-yb-context="saved"]'), note = root && $('[data-yb-note]', root), off = [];
    if (root) {
      off = $$('input,button', root).filter(function (e) { return !e.disabled; });
      off.forEach(function (e) { e.disabled = true; });
      root.setAttribute('data-yb-link', 'busy');
      if (note) note.textContent = i18n.t('js.yb.link_signing');
    }
    verify(email).then(function (r) {
      if (root) {
        off.forEach(function (e) { e.disabled = false; });
        root.removeAttribute('data-yb-link');
        if (note) note.textContent = '';
      }
      if (r.ok) core.store.remove(SLOT, 'pending');
      handOver({ ok: !!r.ok, email: email, added: r.added | 0, reason: r.reason });
    });
  }

  // --- any other browser: show the code, offer to sign in here ---
  function card() {
    var c = $('[data-yb-link-card]'), page = $('[data-yb-saved]');
    if (!c) return;
    var form = $('[data-yb-link-form]', c), inp = $('[data-yb-link-email]', c), go = $('[data-yb-link-go]', c),
      note = $('[data-yb-link-note]', c), title = $('#yb-lcard-title'), busy = false;
    $('[data-yb-link-code]', c).textContent = group(code);
    c.hidden = false;
    if (page) page.setAttribute('data-yb-link', 'card');   // the page's own sign-in card steps aside (css)
    if (title) title.focus();

    $('[data-yb-link-copy]', c).addEventListener('click', function () {
      copyText(code).then(function (ok) { if (ok) core.toast({ text: i18n.t('js.yb.link_copied') }); });
    });
    inp.addEventListener('input', function () { note.textContent = ''; });
    form.addEventListener('submit', function (e) {
      var v = String(inp.value || '').trim().toLowerCase();
      e.preventDefault();
      if (busy) return;
      if (!EMAIL.test(v)) { note.textContent = i18n.t('js.yb.link_email'); inp.focus(); return; }
      busy = go.disabled = true;
      note.textContent = '';
      verify(v).then(function (r) {
        busy = go.disabled = false;
        if (r.ok) {
          core.store.remove(SLOT, 'pending');
          c.hidden = true;
          if (page) page.removeAttribute('data-yb-link');
          handOver({ ok: true, email: v, added: r.added | 0 });
          return;
        }
        note.textContent = r.reason === 'limit' ? i18n.t('js.yb.link_limit') : r.reason === 'network' ? i18n.t('js.yb.link_network') : i18n.t('js.yb.link_mismatch');
      });
    });
  }

  function run() {
    var m = CODE_HASH.exec(window.location.hash || ''), email;
    if (!m) return;
    code = m[1];
    try { window.history.replaceState(null, '', window.location.pathname + window.location.search); } catch (e) { log('replaceState'); }
    if (!core.flags.on('signin') || core.session.state().signedIn) { code = ''; return; }
    email = pendingEmail();
    core.events.emit('signin_link_open', { tool: TOOL, same_browser: !!email });
    if (email) { auto(email); } else { card(); }
  }

  // --- start ---
  // The core and britten-your-britten.js are deferred scripts that sit after this one in the page, so wait
  // for DOMContentLoaded (every deferred script has run by then) before asking the core.
  function boot() {
    if (!window.BrittenCore) return;
    window.BrittenCore.ready(function () {
      core = window.BrittenCore;
      i18n = core.i18n;
      run();
      log('ready');
    });
  }
  if (document.readyState === 'complete') { boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
})();
